<ng-container *ngIf="vm$ | async as vm">
  <ng-container *ngIf="status$ | async as status">
    <div class="guts-m-t-1 guts-m-b-2-half">
      <div class="l_flex l_flex-justify">
        <div class="l_flex guts-p-l-1-half container-wrap">
          <button
            df-button
            dfButtonType="passive"
            class="collection-tab-button"
            [class.collection-tab-button__selected]="
              vm.filter.currentItemClassifier === 'learning'
            "
            [class.collection-tab-button__unselected]="
              vm.filter.currentItemClassifier !== 'learning'
            "
            [attr.aria-pressed]="vm.filter.currentItemClassifier === 'learning'"
            (click)="setClassifier('learning')"
            data-dgat="profile-collection-241"
          >
            {{ i18n.dgProfileOverview_LearningTitle }}
          </button>
          <button
            df-button
            dfButtonType="passive"
            class="collection-tab-button"
            [class.collection-tab-button__selected]="
              vm.filter.currentItemClassifier === 'experiences'
            "
            [class.collection-tab-button__unselected]="
              vm.filter.currentItemClassifier !== 'experiences'
            "
            [attr.aria-pressed]="
              vm.filter.currentItemClassifier === 'experiences'
            "
            (click)="setClassifier('experiences')"
            data-dgat="profile-collection-50c"
          >
            {{ i18n.Core_ExperiencesDisplayName }}
          </button>
          <button
            df-button
            dfButtonType="passive"
            class="collection-tab-button"
            [class.collection-tab-button__selected]="
              vm.filter.currentItemClassifier === 'achievements'
            "
            [class.collection-tab-button__unselected]="
              vm.filter.currentItemClassifier !== 'achievements'
            "
            [attr.aria-pressed]="
              vm.filter.currentItemClassifier === 'achievements'
            "
            (click)="setClassifier('achievements')"
            data-dgat="profile-collection-54d"
          >
            {{ i18n.Core_Achievements }}
          </button>
          <button
            df-button
            dfButtonType="passive"
            class="collection-tab-button"
            [class.collection-tab-button__selected]="
              vm.filter.currentItemClassifier === 'pathways'
            "
            [class.collection-tab-button__unselected]="
              vm.filter.currentItemClassifier !== 'pathways'
            "
            [attr.aria-pressed]="vm.filter.currentItemClassifier === 'pathways'"
            (click)="setClassifier('pathways')"
            data-dgat="profile-collection-53f"
          >
            {{ i18n.Core_Pathways }}
          </button>
          <button
            df-button
            dfButtonType="passive"
            class="collection-tab-button"
            [class.collection-tab-button__selected]="
              vm.filter.currentItemClassifier === 'plans'
            "
            [class.collection-tab-button__unselected]="
              vm.filter.currentItemClassifier !== 'plans'
            "
            [attr.aria-pressed]="vm.filter.currentItemClassifier === 'plans'"
            (click)="setClassifier('plans')"
            data-dgat="profile-collection-53f"
          >
            {{ i18n.Core_Plans }}
          </button>
          <div
            role="region"
            aria-live="polite"
            aria-atomic="true"
            class="a11y-hide"
          >
            <p>{{ collectionAnnouncement }}</p>
          </div>

          <dgx-profile-collection-sorting-v1
            *ngIf="pathwaysOrPlansDisplayed && vm.isMobile"
            class="l_flex l_flex-center"
          ></dgx-profile-collection-sorting-v1>
        </div>
        <div
          class="l_flex-center guts-p-l-1-half guts-m-r-2 m-guts-m-t-1"
          *ngIf="ownerIsViewing"
        >
          <button
            *ngIf="
              !pathwaysOrPlansDisplayed &&
              !(hasError | async) &&
              !!vm.items.length
            "
            df-button
            dfButtonType="passive"
            (click)="toggleBulkEditMode()"
            class="
              collection-tab-button collection-tab-button__unselected
              guts-m-r-1
            "
            data-dgat="profile-collection-6dc"
          >
            <span
              *ngIf="!vm.bulkUpdateVM.enabled"
              data-dgat="profile-collection-ba8"
              >{{ i18n.Core_Select }}</span
            >
            <span *ngIf="vm.bulkUpdateVM.enabled">{{ i18n.Core_Cancel }}</span>
          </button>

          <button
            *ngIf="
              !!vm.addKeys.length &&
              vm.filter.currentItemClassifier !== 'experiences'
            "
            #addButton
            df-button
            dfButtonType="primary"
            [dgxPopoverTrigger]="addItemsPopover"
            class="add-content-button"
            data-dgat="profile-collection-9d1"
          >
            <div class="l_flexbar gap-full-half">
              <df-icon icon="plus"></df-icon>
              <div>{{ i18n.Core_Add }}</div>
            </div>
          </button>

          <button
            *ngIf="
              vm.filter.currentItemClassifier === 'experiences' &&
              !showExperienceTypes
            "
            #addExperienceButton
            df-button
            dfButtonType="primary"
            (click)="showAddModal(vm.addKeys[0])"
            class="add-content-button"
            data-dgat="profile-collection-586"
          >
            <div class="l_flexbar gap-full-half">
              <df-icon icon="plus"></df-icon>
              <div>{{ i18n.Core_Add }}</div>
            </div>
          </button>

          <dgx-add-experience-menu
            *ngIf="
              vm.filter.currentItemClassifier === 'experiences' &&
              showExperienceTypes
            "
            (addExperience)="addExperienceWithId($event)"
          ></dgx-add-experience-menu>
        </div>
      </div>
    </div>

    <div *ngIf="showFilters | async" class="guts-m-b-2-half">
      <div class="grid__col-12 guts-p-v-0 guts-p-l-1">
        <div class="grid__cell">
          <div class="collection-filter-bar l_flex l_flex-justify">
            <div
              class="
                l_flex l_flex-row
                facet-filter__wrapper
                l_flexbar
                grid--wrap
                container-wrap
              "
            >
              <dgx-profile-collection-search-v1></dgx-profile-collection-search-v1>

              <dgx-type-facet-filter-v1
                *ngIf="
                  vm.filter.currentItemClassifier !== 'experiences' &&
                  !status.loading
                "
              ></dgx-type-facet-filter-v1>

              <dgx-facet-filters-v1
                *ngIf="!!vm.displayFacets.length && !status.loading"
              ></dgx-facet-filters-v1>

              <dgx-date-facet-filter-v1
                *ngIf="!pathwaysOrPlansDisplayed && !status.loading"
              ></dgx-date-facet-filter-v1>
              <button
                *ngIf="hasFilterValues && !status.loading"
                df-button
                dfButtonType="clear"
                class="color-blue guts-m-l-2 ib l_flex-center"
                (click)="resetFilters()"
                [attr.aria-label]="i18n.Core_ClearFilters"
                data-dgat="profile-collection-912"
              >
                <df-icon icon="cross" size="small"></df-icon>
                {{ i18n.Core_ClearFilters }}
              </button>

              <div *ngIf="status.loading" class="l_flex m-l_flex">
                <div
                  *ngFor="let i of [1, 2, 3, 4]"
                  class="filter-placeholder guts-m-h-half"
                  data-dgat="profile-collection-760"
                >
                  <dgx-skeleton type="formfield"></dgx-skeleton>
                </div>
              </div>
            </div>

            <dgx-profile-collection-sorting-v1
              *ngIf="pathwaysOrPlansDisplayed && !vm.isMobile"
              class="l_flex"
            ></dgx-profile-collection-sorting-v1>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!!vm.items.length && (!status.loading || status.appending)">
      <div class="grid__col-12 grid__col--bleed">
        <div class="load-wrap">
          <dgx-profile-collection-bulk-update-v1
            *ngIf="vm.bulkUpdateVM.enabled"
          >
          </dgx-profile-collection-bulk-update-v1>
          <ul class="grid" *ngIf="vm.items">
            <!-- Do not use track by! bulk edit selection doesn't work otherwise -->
            <li
              *ngFor="let item of vm.items; let i = index"
              dgxIntersectionObserver
              (onIntersection)="onIntersection(item, i)"
              class="grid__col-xs-6 grid__col-sm-4 grid__col-lg-3 guts-p-t-0"
              data-dgat="profile-collection-059"
              #itemTile
            >
              <div
                id="profileCollectionItem{{ i }}"
                class="tile__wrapper tile__wrapper--collection center-item"
                (mouseenter)="showCheckbox(item.userItemId)"
                (mouseleave)="hideCheckbox()"
              >
                <div
                  *ngIf="!pathwaysOrPlansDisplayed"
                  class="tile__selection guts-m-r-1"
                >
                  <input
                    type="checkbox"
                    [attr.aria-label]="i18n.UserController_BulkEditSelectLabel"
                    class="tile__selection-checkbox"
                    [checked]="
                      isItemSelected(item, vm.bulkUpdateVM.selectedItems)
                    "
                    (change)="toggleItemSelection(item)"
                    [ngClass]="{
                      'tile__selection-checkbox--visible': shouldShowCheckBox(
                        item,
                        vm.bulkUpdateVM.selectedItems,
                        vm.bulkUpdateVM.enabled
                      )
                    }"
                    (focus)="showCheckbox(item.userItemId)"
                    (blur)="hideCheckbox()"
                    data-dgat="profileCollection-9e5"
                  />
                </div>

                <div
                  *ngIf="isOutcomeTile(item.contentType)"
                  (click)="onItemClicked(item)"
                  [attr.aria-role]="vm.bulkUpdateVM.enabled ? 'button' : 'none'"
                  [tabIndex]="vm.bulkUpdateVM.enabled ? 0 : -1"
                  [class.cursor-pointer]="vm.bulkUpdateVM.enabled"
                  [class.tile-wrapper]="vm.isMobile"
                  class="full-height"
                >
                  <dgx-user-outcome-tile-v2
                    [userOutcome]="item"
                    [owner]="owner"
                    [hideMenu]="!!vm.bulkUpdateVM.enabled"
                    [isSelected]="
                      isItemSelected(item, vm.bulkUpdateVM.selectedItems)
                    "
                    [showSelectOption]="true"
                    [expandCard]="vm.indexesOfCardsToExpand.includes(i)"
                    [tileIndex]="i"
                    (clickedTitleEllipses)="onClickTitleEllipses($event)"
                  ></dgx-user-outcome-tile-v2>
                </div>

                <div
                  *ngIf="isExperienceTile(item.contentType)"
                  (click)="onItemClicked(item)"
                  [attr.aria-role]="vm.bulkUpdateVM.enabled ? 'button' : 'none'"
                  [tabIndex]="vm.bulkUpdateVM.enabled ? 0 : -1"
                  [class.cursor-pointer]="vm.bulkUpdateVM.enabled"
                  [class.tile-wrapper]="vm.isMobile"
                  class="full-height"
                >
                  <dgx-user-experience-tile
                    [userExperience]="item"
                    [owner]="owner"
                    [hideMenu]="!!vm.bulkUpdateVM.enabled"
                    [isSelected]="
                      isItemSelected(item, vm.bulkUpdateVM.selectedItems)
                    "
                    [expandCard]="vm.indexesOfCardsToExpand.includes(i)"
                    [tileIndex]="i"
                    (clickedTitleEllipses)="onClickTitleEllipses($event)"
                  ></dgx-user-experience-tile>
                </div>

                <div
                  (click)="onItemClicked(item)"
                  [attr.aria-role]="vm.bulkUpdateVM.enabled ? 'button' : 'none'"
                  [tabIndex]="vm.bulkUpdateVM.enabled ? 0 : -1"
                  *ngIf="isInputTile(item.contentType)"
                  [class.tile-wrapper]="vm.isMobile"
                  [class.cursor-pointer]="vm.bulkUpdateVM.enabled"
                  class="full-height"
                >
                  <dgx-tile-launcher
                    [item]="item.content"
                    [modifyOptionsFn]="modifyOptionsFn"
                    [hideFooter]="vm.bulkUpdateVM.enabled"
                    [isSelected]="
                      isItemSelected(item, vm.bulkUpdateVM.selectedItems)
                    "
                    [isClickable]="!vm.bulkUpdateVM.enabled"
                    [expandCard]="vm.indexesOfCardsToExpand.includes(i)"
                    [tileIndex]="i"
                    (clickedTitleEllipses)="onClickTitleEllipses($event)"
                  ></dgx-tile-launcher>
                </div>

                <div
                  *ngIf="isPlanOrPathwayTile(item.contentType)"
                  [class.tile-wrapper]="vm.isMobile"
                  class="pathway-tile-height-normalization"
                >
                  <dgx-tile-launcher [item]="item.content"></dgx-tile-launcher>
                </div>
              </div>
            </li>
            <li
              *ngFor="let count of vm.placeholderTiles; let last = last"
              class="collection-placeholder-tile guts-m-h-1-half"
              [class.guts-m-r-0]="last"
              data-dgat="profile-collection-4ea"
            ></li>
            <ul class="grid guts-m-t-2" *ngIf="status.appending">
              <li
                *ngFor="let i of emptyTiles"
                class="grid__col-xs-6 grid__col-sm-4 grid__col-lg-3 guts-p-t-0"
                data-dgat="profile-collection-65c"
              >
                <div class="empty-tile">
                  <dgx-skeleton
                    type="userOutcome"
                    layout="random"
                  ></dgx-skeleton>
                </div>
              </li>
            </ul>
          </ul>

          <div
            *ngIf="vm.hasMoreItems"
            class="
              l_flex
              m-l_flex
              l_flex-justify-center
              m-l_flex-justify-center
              guts-m-t-2
            "
          >
            <button
              df-button
              dfButtonType="primary"
              (click)="updateCollection(true)"
              data-dgat="profile-collection-e7f"
              class="add-content-button"
            >
              {{ i18n.Core_ShowMore }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <ul class="grid" *ngIf="status.loading && !status.appending">
      <li
        *ngFor="let i of emptyTiles"
        data-dgat="profileCollection-137"
        class="
          grid__col-xs-6 grid__col-sm-4 grid__col-lg-3
          l_flex
          m-l_flex
          l_flex-middle
        "
      >
        <div class="empty-tile">
          <dgx-skeleton
            type="userOutcome"
            layout="random"
            [isMobile]="vm.isMobile"
          ></dgx-skeleton>
        </div>
      </li>
    </ul>

    <div *ngIf="!status.loading && !vm.items.length">
      <div class="l_flex l_flex-column l_flex-center-children center-text">
        <div class="guts-p-t-3-half guts-p-b-2">
          <img
            [src]="allItemsRemovedByFiltersImage | blobifyUrl: true"
            alt=""
            role="presentation"
            width="360px"
            height="275px"
          />
        </div>
        <div *ngIf="!hasFilterValues && ownerIsViewing && !(hasError | async)">
          <div>
            <span class="par font-semibold">{{
              getEmptyStateTitle(vm.filter.currentItemClassifier, true)
            }}</span>
          </div>
          <p class="par--small par--light">
            {{ i18n.UserController_AddToCollectionDescription }}
          </p>
        </div>
        <div *ngIf="hasError | async">
          <div>
            <span class="par font-semibold">{{ i18n.Ext_ErrorMessage }}</span>
          </div>
          <p class="par--small par--light">
            {{ i18n.Core_PleaseTryAgain }}
          </p>
        </div>
        <div *ngIf="!hasFilterValues && !ownerIsViewing && !(hasError | async)">
          <div>
            <span class="par font-semibold">{{
              getEmptyStateTitle(vm.filter.currentItemClassifier, false)
            }}</span>
            <p class="par--small par--light">
              {{ i18n.UserController_AddToCollectionDescription }}
            </p>
          </div>
        </div>
        <div *ngIf="hasFilterValues && !(hasError | async)">
          <div>
            <span class="par font-semibold">{{
              i18n.ProfileCtrl_NoExactMatches
            }}</span>
            <p class="par--small par--light">
              {{ i18n.ProfileCtrl_NoExactMatchesHelp }}
            </p>
            <button
              *ngIf="hasSearchTerm"
              df-button
              dfButtonType="clear"
              class="color-blue guts-m-full-1 ib"
              (click)="resetFilters()"
              [attr.aria-label]="i18n.Core_ClearFilters"
              data-dgat="profile-collection-d1f"
            >
              {{ i18n.Core_ClearFilters }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <dgx-popover
      #addItemsPopover
      [popoverArrowHidden]="true"
      placement="bottom-right"
    >
      <div class="guts-p-h-2 guts-p-v-1-half sorting-popover">
        <ul>
          <li
            *ngFor="let addKey of vm.addKeys; let last = last"
            [class.guts-m-b-1]="!last"
            data-dgat="profile-collection-fc5"
          >
            <button
              df-button
              dfButtonType="clear"
              (click)="showAddModal(addKey)"
              data-dgat="profile-collection-2b7"
            >
              <span class="par par--small par--light_a font-semibold">{{
                addKey.label
              }}</span>
            </button>
          </li>
        </ul>
      </div>
    </dgx-popover>
    <div class="footer-glasses guts-m-t-15"></div>
  </ng-container>
</ng-container>
